import { memo } from "react";

import { Routes } from "../../../../router/types";
import { singleRoutesFactory } from "../SingleRoute/SingleRouteFactory";

import styles from "./RoutesContainer.module.scss";

type RoutesContainerProps = {
  readonly currentRoute: string;
  readonly routes: Routes;
};

export const RoutesContainer = memo<RoutesContainerProps>(
  ({ currentRoute, routes }) => (
    <ul className={styles.container}>
      {singleRoutesFactory(routes, currentRoute)}
    </ul>
  )
);
